import styled, { css } from 'styled-components'

export interface TimelineDateStyledProps {
  $size?: 'small' | 'medium'
}

const sizeStyles = {
  small: css`
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
  `,
  medium: css`
    font-size: ${({ theme }) => theme.typography.fontSize.small};
  `,
}

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<TimelineDateStyledProps>`
  position: absolute;
  left: 0;
  top: 16px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  width: 80px;
  white-space: nowrap;
  text-align: center;

  ${({ $size = 'small' }) => sizeStyles[$size]}

  @media (max-width: 768px) {
    position: relative;
    left: 0;
    top: 0;
    margin-bottom: 8px;
    text-align: left;
    width: auto;
  }
`
